import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import CustomerDashboard from './pages/CustomerDashboard';
import NewOrderPage from './pages/NewOrderPage';
import ShopsPage from './pages/ShopsPage';
import OwnerRequestsPage from './pages/OwnerRequestsPage';
import OwnerOrdersPage from './pages/OwnerOrdersPage';
import OwnerShopPage from './pages/OwnerShopPage';
import './index.css';

function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}><div className="spinner" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  return (
    <div className="app-layout">
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/shops" element={<ShopsPage />} />

        {/* Customer routes */}
        <Route path="/customer/dashboard" element={
          <ProtectedRoute role="customer"><CustomerDashboard /></ProtectedRoute>
        } />
        <Route path="/customer/new-order" element={
          <ProtectedRoute role="customer"><NewOrderPage /></ProtectedRoute>
        } />

        {/* Owner routes */}
        <Route path="/owner/requests" element={
          <ProtectedRoute role="laundry_owner"><OwnerRequestsPage /></ProtectedRoute>
        } />
        <Route path="/owner/orders" element={
          <ProtectedRoute role="laundry_owner"><OwnerOrdersPage /></ProtectedRoute>
        } />
        <Route path="/owner/shop" element={
          <ProtectedRoute role="laundry_owner"><OwnerShopPage /></ProtectedRoute>
        } />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
